// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3tMrU","text":"SelectPayment_text__2vt22","title":"SelectPayment_title__GBdqf","btn":"SelectPayment_btn__3pLN8"};